<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="14" />
      <div class="box5">
        <div style="overflow: hidden;display: flex;justify-content: space-between;padding:0 10px;cursor:pointer;">
          <div class="box6">增加收票方式</div>
          <div class="box6" ><router-link to="/order" style="color:rgb(43, 154, 52)">返回开票</router-link></div>
        </div>

        <div v-if="ShowHidden">
          <div class="box7"></div>
          <div style="overflow: hidden; margin-top: 2%;">
            <div class="item_title"><span style="color: red;">*</span> 收票方式：</div>
            <div class="item_title" style="text-align: left; margin-left: 20px;">纸质发票</div>
            <div @click="chang_zhizhi_show" style="float: right;">
                <div class="zhankai">{{zhizhi_show ? '收起' : '展开'}}</div>
                <a-icon :type="zhizhi_show ? 'up' : 'down'" style="float: left;margin-top: 13px;color: #2B9A34;" />
            </div>
          </div>

          <div v-if="zhizhi_show">
            <div style="overflow: hidden; margin-top: 2%;">
                <div class="item_title"><span style="color: red;">*</span> 姓名：</div>
                <a-input v-model="obj_PAPER.name" placeholder="请输入收票人姓名" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
              </div>
              <div style="overflow: hidden; margin-top: 2%;">
                <div class="item_title"><span style="color: red;">*</span> 手机号码：</div>
                <a-input v-model="obj_PAPER.mobile" placeholder="请输入收票人手机号码" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
              </div>

               <div style="overflow: hidden; margin-top: 2%;">
                <div class="item_title"><span style="color: red;">*</span> 收票地址</div>
                <a-input v-model="obj_PAPER.address" placeholder="请输入收票地址" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
              </div>

              <div style="overflow: hidden; margin-top: 2%;">
                  <div class="item_title"><span style="color: red;"></span> </div>
                <a-checkbox v-model="obj_PAPER.defaults" style="margin-left: 20px;">
          设为默认
        </a-checkbox>
              </div>

              <div style="overflow: hidden; margin-top: 2%;">
                <div class="item_title"><span style="color: red;"></span> </div>
                <div class="submit_but" @click="zhizhifapiao(0)" style="margin-left: 20px; float: left;">保存</div>
              </div>

          </div>
        </div>

        <div v-if="Show">
          <div class="box7"></div>
            <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;">*</span> 收票方式：</div>
                        <div class="item_title" style="text-align: left; margin-left: 20px;width: 300px;">电子发票（仅支持增值税普通发票）</div>
                        <div @click="chang_dianzi_show" style="float: right;">
                            <div class="zhankai">{{dianzi_show ? '收起' : '展开'}}</div>
                            <a-icon :type="dianzi_show ? 'up' : 'down'" style="float: left;margin-top: 13px;color: #2B9A34;" />
                        </div>
                      </div>

                      <div v-if="dianzi_show">
                        <div style="overflow: hidden; margin-top: 2%;">
                            <div class="item_title"><span style="color: red;">*</span> 姓名：</div>
                            <a-input v-model="obj_ELECTRONIC.name" placeholder="请输入收票人姓名" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                          </div>
                          <div style="overflow: hidden; margin-top: 2%;">
                            <div class="item_title"><span style="color: red;">*</span> 手机号码：</div>
                            <a-input v-model="obj_ELECTRONIC.mobile" placeholder="请输入收票人手机号码" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                          </div>

                          <div style="overflow: hidden; margin-top: 2%;">
                              <div class="item_title"><span style="color: red;"></span> </div>
                            <a-checkbox v-model="obj_ELECTRONIC.defaults" style="margin-left: 20px;">
                      设为默认
                    </a-checkbox>
                          </div>

                          <div style="overflow: hidden; margin-top: 2%;">
                            <div class="item_title"><span style="color: red;"></span> </div>
                            <div class="submit_but" @click="zhizhifapiao(1)" style="margin-left: 20px; float: left;">保存</div>
                          </div>
                      </div>

                  </div>
        </div>


    </div>
    <foot/>
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
    import foot from "../public/foot";
    export default {
        name: "integral",
        components: {
            userLeft,
            htmlHeader,
            foot,
        },
        data() {
            return {
                ShowHidden:false,//纸质发票显示
                Show:false,//电子发票显示
                zhizhi_show: true, //纸质发票显示
                dianzi_show: true, //电子发票显示
                obj_PAPER: {
                    address: "",
                    defaults: false,
                    mobile: "",
                    name: "",
                    types: "PAPER", // PAPER 纸质
                    userId: ""
                },
                obj_ELECTRONIC: {
                    address: "",
                    defaults: false,
                    mobile: "",
                    name: "",
                    types: "ELECTRONIC", // ELECTRONIC // 电子
                    userId: ""
                },
                edit_code: null, //编辑类型
            };
        },
        methods: {
            //获取urlid
            get_urlid(){
              let id = this.$route.query.id;
              if(id==1){
                this.ShowHidden = true;
              }else if (id==0){
                this.Show =true;
              }
            },
            // 编辑进入
            get_user_invoice_receive_details() {
              this.api.get_user_invoice_receive_details(this.$route.query.uuid).then(res => {
                if(res.ok) {
                  this.edit_code = res.data.types
                  if(res.data.types == 'PAPER') {
                    this.obj_PAPER = res.data
                    this.dianzi_show = false
                    this.ShowHidden = true
                  }else if(res.data.types == 'ELECTRONIC') {
                    this.obj_ELECTRONIC = res.data
                    this.zhizhi_show = false
                    this.Show = true
                  }

                }else {
                  this.$message.error(res.message);
                }
              })
            },
            // 展开隐藏
            chang_dianzi_show() {
              // if(this.edit_code == 'ELECTRONIC') {
              //   return false
              // }
              this.dianzi_show = !this.dianzi_show
            },
            chang_zhizhi_show() {
              // if(this.edit_code == 'PAPER') {
              //   return false
              // }
              this.zhizhi_show = !this.zhizhi_show
            },
            // 保存发票
            zhizhifapiao(e) {
              let obj = {}
                if (e == 0) {
                  obj = this.obj_PAPER
                    // 纸质发票
                    if (this.obj_PAPER.name == '' || this.obj_PAPER.address == '') {
                        this.$message.error("请填写完整");
                        return false
                    }
                    if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.obj_PAPER.mobile)) {
                        this.$message.error("请输入正确的手机号");
                        return false;
                    }
                } else if (e == 1) {
                  obj = this.obj_ELECTRONIC
                    // 电子发票
                    if (this.obj_ELECTRONIC.name == '') {
                        this.$message.error("请填写完整");
                        return false
                    }
                    if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.obj_ELECTRONIC.mobile)) {
                        this.$message.error("请输入正确的手机号");
                        return false;
                    }
                }
                this.api.add_user_invoice_receive(obj).then(res => {
                  if(res.ok) {
                    this.$message.success(res.message)
                    this.$router.push('/control_over_invoices')
                  }else {
                    this.$message.error(res.message)
                  }
                })
            },
        },
        created() {
          if(this.$route.query.id){
            this.get_urlid()
          }
          if(this.$route.query.uuid) {
            this.get_user_invoice_receive_details()
          }
        },
    };
</script>

<style scoped>
    .submit_but {
        width: 100px;
        height: 40px;
        border: 1px solid #2B9A34;
        margin: 4% auto;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
        cursor: pointer;
    }

    .xuxian {
        width: 100%;
        height: 1px;
        border-bottom: 1px dashed #E8E6E6;
        margin-top: 2%;
    }

    .item_title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 42px;
        text-align: right;
        float: left;
        margin-top: 5px;
        width: 20%;
    }

    .box14 {
        width: 120px;
        height: 32px;
        border: 1px solid #2C9A34;
        float: right;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2C9A34;
    }

    .box13 {
        width: 16.6666%;
        height: 100%;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
    }

    .box12 {
        width: 100%;
        height: 40px;
        background: #F4F4F4;
        margin-top: 4%;
    }

    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }

    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }

    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }

    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }

    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }

    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }

.box5 {
        min-height: 1023px;
        width: 80%;
        /* min-height: 1023px; */
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
        min-height: 1023px;
    }

    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }

    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }

    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }

    .zhankai {
        color: #2B9A34;
        float: left;
        font-size: 14px;
        margin-top: 10px;
        margin-right: 10px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/add_ticket_collection_method.vue